export const PushNotificationEvent = {
  DELIVERY_NOTE_STATUS_CHANGED: 'DELIVERY_NOTE_STATUS_CHANGED',
  NEW_ORDER_RECEIVED: 'NEW_ORDER_RECEIVED',
  SECONDE_VIE_NOTIFICATION: 'SECONDE_VIE_NOTIFICATION',
}
